import useLoginTepngUser from "../../hooks/UseLoginTepngUser";

const LoginTepngUser = () => {
  useLoginTepngUser();

  return <></>;
};

export default LoginTepngUser;
